enum FrequencyActivityAction {
  SCHEDULE_ACTIVITY = "scheduleActivity",
  ADD_TO_ROUTE = "addToRoute",
  VIEW_ACTIVITY_HISTORY = "viewActivityHistory",
}

export default FrequencyActivityAction;
